import React, { useEffect, useState } from "react"
import { ModalPopUp } from "../../common/element/ModalPopUp"
import { MenuAdmin } from "../MenuAdmin"
import { Header } from "../../common/header/Header"
import { IModalMessage } from "../../../types/error/IModalMessage"
import { useNavigate, useParams } from "react-router-dom"
import * as TrinityAPI from "../../../requests/TrinityAPI"
import { CONFIG } from "../../../CONFIG"
import { IBrockmanDetailDto } from "../../../types/brockman/IBrockmanDetailDto"
import { IBrockmanBankDto } from "../../../types/brockman/IBrockmanBankDto"
import { BrockmanDetailPopUp } from "./BrockmanDetailPopUp"

export const BrockmanBillDetail = () => {
  const [modalMessage, setModalMessage] = useState<IModalMessage | null>(null)
  const [brockman, setBrockman] = useState<IBrockmanBankDto>()
  const [brockmanDetail, setBrockmanDetail] = useState<IBrockmanDetailDto>()
  const [editFieldName, setEditFieldName] = useState<string | undefined>()
  const [editFieldLabel, setEditFieldLabel] = useState("")
  const params = useParams()
  const navigate = useNavigate()

  useEffect(() => {
    if (!params.id) return
    TrinityAPI.getBrockmanBank(params.id, response => {
      if (response.status === 200) {
        setBrockman(response.data)
        setBrockmanDetail(response.data.brockmanDetail)
      } else {
        setModalMessage({ title: "Ошибка!", text: "Ошибка получения банка: " + response.data.message })
      }
    })
  }, [])

  const handleEdit = (label: string, name: string) => {
    setEditFieldLabel(label)
    setEditFieldName(name)
  }

  const submit = (detail: IBrockmanDetailDto | undefined) => {
    if (!detail) return
    setEditFieldName(undefined)
    setEditFieldLabel("")
    TrinityAPI.updateBrockmanDetail(detail, response => {
      if (response.status === 200) {
        setBrockmanDetail(response.data.brockmanDetail)
      }
    })
  }

  return (
    <>
      <ModalPopUp message={modalMessage} close={() => setModalMessage(null)} />
      <MenuAdmin active={"dashboard"} />
      <section className="new-contragent">
        <Header />
        <div className="container">
          <div className="profile-block">
            <img src={`${CONFIG.STORAGE_URL}/${brockman?.avatarPath}`} alt="" className="profile-icon-img" />
            <div className="profile-block-about">
              <h4 className="profile-name">{brockman?.name}</h4>
              <button className="btn grey-btn" onClick={() => navigate(`/admin/brockman/${params.id}`)}>
                Редактировать
              </button>
            </div>
          </div>

          <ul className="quick-actions">
            <li className="quick-action-block">
              <p className="quck-action-text">Received From</p>
              <p className="flex-column-text-card">{brockmanDetail?.name}</p>
              <p className="edit-card" onClick={() => handleEdit("Received From", "name")}>
                Редактировать
              </p>
            </li>
            {/*<li className="quick-action-block">*/}
            {/*  <p className="quck-action-text">*/}
            {/*    Banking Details*/}
            {/*  </p>*/}
            {/*  <p className="flex-column-text-card">*/}
            {/*    {brockmanDetail?.bankingDetails}*/}
            {/*  </p>*/}
            {/*  <p className="edit-card" onClick={() => handleEdit("Banking Details", "bankingDetails")}>*/}
            {/*    Редактировать*/}
            {/*  </p>*/}
            {/*</li>*/}
            <li className="quick-action-block">
              <p className="quck-action-text">Beneficiary Address</p>
              <p className="flex-column-text-card">{brockmanDetail?.beneficiaryAddress}</p>
              <p className="edit-card" onClick={() => handleEdit("Beneficiary Address", "beneficiaryAddress")}>
                Редактировать
              </p>
            </li>
          </ul>
        </div>
      </section>

      {brockmanDetail ? (
        <BrockmanDetailPopUp
          setFieldName={setEditFieldName}
          brockmanDetail={brockmanDetail}
          fieldName={editFieldName}
          label={editFieldLabel}
          _submit={submit}
        />
      ) : (
        <></>
      )}
    </>
  )
}
